import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import DataPicker from "../DataPicker";
import { DataPickerMeta } from "../data-picker/dataPicker";
import { useDataCatalogContext } from "../data-picker/DataCatalogContext";
import FlussNodePanelField from "./FlussNodePanelField";
import { FlussElementSelection } from "modules/fluss/types/fluss";
import { bindingForKind, primaryBindingFor, updateBinding } from "./fluss-node-panel-utils";

interface RecordSourceFieldProps {
    value?: string;
    onChange: (value: string, info?: DataPickerMeta) => void;
    disabled?: boolean;
    onResolved?: (info: DataPickerMeta) => void;
}

const RecordSourceField = ({ value, onChange, disabled, onResolved }: RecordSourceFieldProps) => {
    const { t } = useTranslation();
    const catalog = useDataCatalogContext();
    const label = String(t("fluss.node_panel.record_source", { defaultValue: "Registro" }));
    return <FlussNodePanelField label={label} fieldPath="recordSource">
        <DataPicker value={value || undefined} onChange={(next, info) => onChange(typeof next === "string" ? next : "", info)}
            allowedTypes={["REFERENCE"]} requireRecordTable allowFixed={false} disabled={disabled} ariaLabel={label} onResolved={onResolved} />
        {!value && catalog.record?.table && <Typography variant="caption" color="text.secondary">
            {t("fluss.node_panel.record_source.trigger_default", { defaultValue: "Registro de origem (gatilho)" })}
        </Typography>}
    </FlussNodePanelField>;
};

export default RecordSourceField;

export const RecordSourceBindingField = ({ selection, modeler, kind, readOnly, onChanged, onResolved, onSelected }: {
    selection: FlussElementSelection;
    modeler: any;
    kind: string;
    readOnly: boolean;
    onChanged: () => void;
    onResolved?: (info: DataPickerMeta) => void;
    onSelected?: (value: string, info?: DataPickerMeta) => void;
}) => {
    const readBinding = () => bindingForKind(selection.businessObject, kind) ||
        (["assignment", "approval", "service"].includes(kind) ? primaryBindingFor(selection.businessObject) : undefined);
    const [value, setValue] = useState(String(readBinding()?.recordSource || ""));
    useEffect(() => setValue(String(readBinding()?.recordSource || "")),
        [selection.id, selection.businessObject, kind]);
    return <RecordSourceField value={value} disabled={readOnly} onResolved={onResolved} onChange={(next, info) => {
        setValue(next);
        updateBinding(selection, modeler, kind, { recordSource: next });
        onSelected?.(next, info);
        onChanged();
    }} />;
};
